/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_About_NetflixInputs */

const de_commons_footer_about_netflix = /** @type {(inputs: Commons_Footer_About_NetflixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Netflix`)
};

/** @type {(inputs: Commons_Footer_About_NetflixInputs) => LocalizedString} */
const en_commons_footer_about_netflix = de_commons_footer_about_netflix;

/**

* @param {Commons_Footer_About_NetflixInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_about_netflix = /** @type {((inputs?: Commons_Footer_About_NetflixInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_About_NetflixInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_about_netflix(inputs)
	return en_commons_footer_about_netflix(inputs)
});